import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ActualizaAlarmasPersonalizadasService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Alarma/ActualizaAlarmasPersonalizadas",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ActualizaAlarmasPersonalizadasService };